// extracted by mini-css-extract-plugin
module.exports = {"c-FloatingLabelInput":"FloatingLabelInput_c-FloatingLabelInput__WLyt7"};